export default __webpack_public_path__ + "2557ec845c9d70298aaef3ad19b8554d.png";